import { render, staticRenderFns } from "./RolesAdd.vue?vue&type=template&id=2a2a08ff&scoped=true&"
import script from "./RolesAdd.vue?vue&type=script&lang=js&"
export * from "./RolesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a08ff",
  null
  
)

export default component.exports